import classNames from 'classnames';

import WhatsAppIcon from '@/assets/icons/whatsapp.svg?react';

type Props = {
  readonly className?: string;
};

/** WhatsApp's brand mark, shown wherever a phone code is delivered over WhatsApp. */
const WhatsAppBadge = ({ className }: Props) => (
  <span
    className={classNames(
      // #25D366 is WhatsApp's mandated brand green; there is no theme token for it.
      'inline-flex size-5 shrink-0 items-center justify-center rounded-md bg-[#25D366] text-white [&_svg]:size-3.5',
      className
    )}
  >
    <WhatsAppIcon />
  </span>
);

export default WhatsAppBadge;
